/** Encodes bounded mono PCM as 16-bit WAV for the local STT adapter. */
export function encodeWav(chunks: Float32Array[], sampleRate: number): Blob {
  const count = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
  if (count > sampleRate * 30 || sampleRate < 8000 || sampleRate > 192000)
    throw new Error('Recording exceeds supported limits.');
  const buffer = new ArrayBuffer(44 + count * 2),
    view = new DataView(buffer);
  const put = (offset: number, text: string) =>
    [...text].forEach((c, i) => view.setUint8(offset + i, c.charCodeAt(0)));
  put(0, 'RIFF');
  view.setUint32(4, 36 + count * 2, true);
  put(8, 'WAVE');
  put(12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, 1, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * 2, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  put(36, 'data');
  view.setUint32(40, count * 2, true);
  let offset = 44;
  for (const chunk of chunks)
    for (const sample of chunk) {
      const n = Math.max(-1, Math.min(1, sample));
      view.setInt16(offset, n < 0 ? n * 32768 : n * 32767, true);
      offset += 2;
    }
  return new Blob([buffer], { type: 'audio/wav' });
}
